import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BOrganizationFetchListCard } from './BOrganizationFetchListCard'

export const BOrganizationPopperListCard = defineComponent({
  name: 'BOrganizationPopperListCard',
  props: {
    ids: {
      type: Array as PropType<string[]>,
      required: true,
    },
    coreIds: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
  },
  render() {
    return (
      <PtPopper data={{ ids: this.ids, coreIds: this.coreIds }} tippyConfig={getAsyncListTippyConfig()} component={BOrganizationFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
